import { Button, Container, Row, Table } from "react-bootstrap";
import Breadcrumbs from "../../components/breadcrumbs";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import RoleManagementModal from "./RoleManagementModal";
import UserPermissionModal from "./UserPermissionModal";

const RoleManagement = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);
  const [showUsersModal, setShowUsersModal] = useState(false);

  useEffect(() => {
    getTableData();
  }, []);

  const getTableData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/coursebuilder-access`)
      .then((response) => {
        setTableData(response.data.data || []);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        toast.error("Error fetching data");
      });
  };

  const handleShowUsers = (module) => {
    setSelectedModule(module);
    setShowUsersModal(true);
  };

  return (
    <Container fluid className="p-4">
      <Breadcrumbs />
      <p className="section-title mb-5">Access Management</p>

      <div className="mb-3 text-end">
        <Button variant="primary" onClick={() => setShowAddModal(true)}>
          Assign Permissions
        </Button>
      </div>

      <Row>
        <Table responsive className="scribe-contents-table">
          <thead>
            <tr>
              <th>Module Name</th>
              <th>User Count</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tableData && tableData.length > 0 ? (
              tableData.map((row) => (
                <tr key={row.id}>
                  <td>{row.tool}</td>
                  <td>{row.users_count || 0}</td>
                  <td>
                    <div className="d-flex justify-content-end gap-3">
                      <img
                        style={{ cursor: "pointer" }}
                        src="/images/eye.svg"
                        alt=""
                        onClick={() => handleShowUsers(row)}
                      />

                      <img
                        style={{ cursor: "pointer" }}
                        src={"/images/edit.svg"}
                        alt="edit"
                        onClick={() => {
                          setSelectedModule(row);
                          setShowAddModal(true);
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: "center", padding: "2rem" }}>
                  <img alt="No data found" src="/images/no-data-found.jpeg" style={{ maxWidth: "400px" }} />
                  <p>No data available</p>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Row>

      {showAddModal && (
        <RoleManagementModal
          show={showAddModal}
          onClose={() => {
            setShowAddModal(false);
            setSelectedModule(null);
          }}
          getData={getTableData}
          toolData={selectedModule}
        />
      )}
      {showUsersModal && selectedModule && (
        <UserPermissionModal
          show={showUsersModal}
          onClose={() => {
            setShowUsersModal(false);
            setSelectedModule(null);
          }}
          toolId={selectedModule.id}
          toolName={selectedModule.tool}
          getData={getTableData}
        />
      )}
    </Container>
  );
};

export default RoleManagement;
